import { ReportActions, SocketParams } from 'src/models';

export function requestReport(payload: SocketParams) {
  return { type: ReportActions.CREATE, payload };
}
